<template>
  <b-col
    id="sidebarContainer"
    cols="4"
    class="d-flex flex-column mh-100"
    :style="{'background-color': backgroundColor, 'color': tabFontColor}"
  >
    <Spinner
      v-if="!appLoaded"
      data-test="loading-spinner"
    />
    <SideBar
      v-if="appLoaded"
      class="vertical-scroll"
    />
    <OrbVizLegal class="p-1 px-3" />
  </b-col>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import Spinner from '@/components/public/Spinner.vue'
import SideBar from '@/components/public/SideBar.vue'
import OrbVizLegal from '@/components/admin/OrbVizLegal.vue'
import { StoryKeys } from '@/types'

const components = {
  Spinner,
  SideBar,
  OrbVizLegal,
}

@Component({ components })
export default class SidePanel extends Vue {
  get appLoaded () {
    return this.$typedStore.activeVisualisation.appLoaded
  }

  get activeTab () {
    return this.$typedStore.public.display.activeTab
  }

  get path () {
    let path: string | undefined
    if (this.$typedStore.activeVisualisation.isPrimaryApp) {
      path = this.activeTab?.path
    } else if (this.$typedStore.activeVisualisation.isSecondaryApp) {
      path = this.activeTab?.secondaryAppPath
    }
    return path ?? ''
  }

  get backgroundColor () {
    return this.$typedStore.primary.entities.nodes.colour(this.path)
  }

  get tabFontColor () {
    return this.$typedStore.primary.app.tabFontColor(this.path, StoryKeys.SIDEBAR_BOT)
  }
}

</script>

<style scoped>

#sidebarContainer {
  /* z-index of a container should always be applied whenever we are coloring the background of a container */
  z-index: 2;
}

</style>
